import { useEffect, useRef, useState } from "react";
import Setting from '../../components/Setting/Setting';

const Settings = ({}) => {
    return (
        <>
            <Setting />
        </>
    )
};

export default Settings;